import PropTypes from 'prop-types';

const PersonIcon = ({ width = '15', height = '16' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2403_61717)">
      <path
        d="M12.8033 2.41155C11.3867 0.99499 9.50332 0.214844 7.5 0.214844C5.49668 0.214844 3.61327 0.99499 2.19668 2.41155C0.780147 3.82812 0 5.71152 0 7.71484C0 9.71816 0.780147 11.6016 2.19668 13.0181C3.61327 14.4347 5.49668 15.2148 7.5 15.2148C9.50332 15.2148 11.3867 14.4347 12.8033 13.0181C14.2199 11.6016 15 9.71816 15 7.71484C15 5.71152 14.2199 3.82812 12.8033 2.41155ZM7.5 14.3359C5.71746 14.3359 4.0974 13.6276 2.9059 12.478C3.55113 10.5065 5.40489 9.15039 7.5 9.15039C9.59511 9.15039 11.4489 10.5065 12.0941 12.478C10.9026 13.6276 9.28254 14.3359 7.5 14.3359ZM5.30273 6.07422C5.30273 4.86265 6.28843 3.87695 7.5 3.87695C8.71157 3.87695 9.69727 4.86265 9.69727 6.07422C9.69727 7.28579 8.71157 8.27148 7.5 8.27148C6.28843 8.27148 5.30273 7.28579 5.30273 6.07422ZM12.7541 11.7389C12.1075 10.2261 10.838 9.07671 9.3036 8.56457C10.0741 8.005 10.5762 7.09721 10.5762 6.07422C10.5762 4.37802 9.1962 2.99805 7.5 2.99805C5.8038 2.99805 4.42383 4.37802 4.42383 6.07422C4.42383 7.09721 4.92589 8.005 5.69643 8.56457C4.16203 9.07671 2.89248 10.2261 2.2459 11.7389C1.38908 10.6228 0.878906 9.22738 0.878906 7.71484C0.878906 4.06396 3.84911 1.09375 7.5 1.09375C11.1509 1.09375 14.1211 4.06396 14.1211 7.71484C14.1211 9.22738 13.6109 10.6228 12.7541 11.7389Z"
        fill="#666666"
      />
    </g>
    <defs>
      <clipPath id="clip0_2403_61717">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0 0.214844)"
        />
      </clipPath>
    </defs>
  </svg>
);

PersonIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default PersonIcon;
